/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_AllInputs */

const en_level_all = /** @type {(inputs: Level_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All floors`)
};

const fr_level_all = /** @type {(inputs: Level_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const ms_sg2_level_all = /** @type {(inputs: Level_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

/**
* | output |
* | --- |
* | "All floors" |
*
* @param {Level_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const level_all = /** @type {((inputs?: Level_AllInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_AllInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_level_all(inputs)
	if (locale === "fr") return fr_level_all(inputs)
	return ms_sg2_level_all(inputs)
});